import React, {useEffect, useRef, useState} from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import {NavLink, useHistory} from "react-router-dom";
import Button from "react-bootstrap/Button";
import axios from "axios";
import apiUrl from "../../shared/config";
import Select from "react-select";
import {motion, AnimatePresence} from "framer-motion";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import {RemoveCircleOutline, ThumbDown, ThumbUp, Edit, InfoOutlined, ThumbsUpDown, Lock, VisibilityOff} from "@material-ui/icons";
import SecondaryExampleGame from "./SecondaryExampleGame/SecondaryExampleGame";
import './ExampleGame.css';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {Tooltip} from "@material-ui/core";
import Form from "react-bootstrap/Form";
import {SuggestedIcon} from "../Icons/Icons";
import {appearAndExit} from "../../utils/commonAnimations";
import {findAssessment} from "../../utils/voteUtils";
import PresetModal from "../UI/Modal/PresetModal/PresetModal";
import Timer from "../UI/Timer/Timer";
import Auth from "../../containers/Auth/Auth";
import PersonRounded from "@material-ui/icons/PersonRounded";
import {useDispatch, useSelector} from "react-redux";
import * as actionTypes from "../../store/actions/actionTypes";
import {formatDate} from "../../utils/dateUtils";
import {formatParagraphs, number_to_icon} from "../../utils/utils";
import TextAreaWithTabs from "../UI/TextAreaWithTabs/TextAreaWithTabs";
import SubmitButtonWarning from "../UI/SubmitButtonWarning/SubmitButtonWarning";
import {
    getEditLock,
    LockType,
    LockResponses,
    overrideEditLock,
    cancelEditLock,
    requestLockUpdate
} from "../../utils/lockUtils";
import EditHistoryWrapper from "../UI/EditHistoryPanel/EditHistoryWrapper";

const lockedText = {
    title: "Update Failed!",
    body: "The attempted updated failed because another user is currently editing this example game. Please copy your changes and close the editing window."
}

const changedText = {
    title: "Update Failed!",
    body: "The attempted updated failed because this example game has been updated since you started editing. Please copy your changes and close the editing window."
}

const unknownText = {
    title: "Update Failed!",
    body: "The attempted update failed for an unknown reason. Please copy your changes and close the editing window."
}

const expiredText = {
    title: "Lock Expired",
    body: "Your editing lock has expired. Please copy your changes and close the editing window."
}

const loginToAddSecondary = {
    title: "Login to Add a Game With Similar Implementation",
    body: ""
}

const loginToRate = {
    title: "Login to Rate this Example Game",
    body: ""
}

export default function ExampleGame({pattern_games, gameSelected, token, patternId, update, userId, authors, patternSelected, allGames, listOfGames, patternEditedDate, designProblems}) {
    const history = useHistory();
    const [addGame, setAddGame] = useState(null);
    const [gameList, setGameList] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [plusIsHovered, setPlusIsHovered] = useState(false)
    const [showButtons, setShowButtons] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editDesc, setEditDesc] = useState("");
    const [editHistoryVersion, setEditHistoryVersion] = useState({});
    const [editDesignProblems, setEditDesignProblems] = useState([]);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [isSuggestedOpen, setIsSuggestedOpen] = useState(false);
    const [isDelOpen, setIsDelOpen] = useState(false);
    const overrideModal = useRef();
    const editFailModal = useRef();
    const [modalText, setModalText] = useState({title: "", body: ""});
    const loginModal = useRef();
    const dispatch = useDispatch();
    const permissions = useSelector(state => state.auth.userPermissions);
    const [primaryFailMessage, setPrimaryFailMessage] = useState('');
    const [showPrimaryFailMessage, setShowPrimaryFailMessage] = useState(false);
    const [secondaryFailMessage, setSecondaryFailMessage] = useState('');
    const [showSecondaryFailMessage, setShowSecondaryFailMessage] = useState(false);
    const [activeHistory, setActiveHistory] = useState([]);

    // console.log("Example Game: " + pattern_games.game_name + " Author Patterns: ")
    // console.log(patterns);
    const closeSuggestedPopover = () => {
        setIsSuggestedOpen(false);
    };

    const openUserProfile = (userId) => {
        closeSuggestedPopover();
        dispatch({type: actionTypes.SELECT_USER, userId: userId});
        dispatch({type: actionTypes.OPEN_USER_MODAL});
    }

    useEffect(() => {
        const list = listOfGames.filter(game => {return (game.label !== pattern_games.game_name) && !pattern_games.secondary_games.some(p => p.game_name === game.label) })
        setGameList(list);
    }, [listOfGames, pattern_games.game_name, pattern_games.secondary_games]);

    const handleAddSecondaryGame = () => {
        const data = {
            pattern_id: +patternId, primary_game_id: pattern_games.game_id, secondary_game_id: addGame
        };

        axios.post(apiUrl + "Pattern/setGame?token=" + token, data)
            .then(response => {
                if (!response.data.message) {
                    console.log('Post successful:', response.data);
                    setShowSecondaryFailMessage(false);
                    setAddGame(null)
                    setIsOpen(false);
                    update();
                } else {
                    setShowSecondaryFailMessage(true);
                    setSecondaryFailMessage(response.data.message);
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
    };

    const handleDeleteAnyGame = (gameId, isSecondary, index = 0) => {
        let data;
        if (isSecondary) {
            data = {
                pattern_id: +patternId, primary_game_id: pattern_games.game_id, secondary_game_id: gameId
            };
        } else {
            data = {
                pattern_id: +patternId, game_id: gameId,
            }
        }

        axios.post(apiUrl + "Pattern/removeGame?token=" + token, data)
            .then(response => {
                console.log('Post successful:', response.data);
                setIsOpen(false);
                update();
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
    };

    const handleEditExampleGame = () => {
        const data = {
            pattern_id: +patternId,
            example_description: editDesc,
            game_id: pattern_games.game_id,
            history_id: editHistoryVersion.history_id,
            design_problems: editDesignProblems ?? pattern_games.design_problems,
            edit: true,
        };

        requestLockUpdate(token, patternId, LockType.EXAMPLE_GAME, patternEditedDate, pattern_games.game_id).then(
                response => {
                    if (response === LockResponses.LOCK_CREATED || response === LockResponses.LOCK_OWNED) {
                        axios.post(apiUrl + "Pattern/setGame?token=" + token, data)
                            .then(response => {
                                if (!response.data.message) {
                                    console.log('Post successful:', response.data);
                                    setIsEditing(false);
                                    setActiveHistory(activeHistory.filter((gameId) => {return gameId !== pattern_games.game_id}))
                                    setShowPrimaryFailMessage(false);
                                    setEditDesc("");
                                    setEditDesignProblems([]);
                                    setEditHistoryVersion({});
                                    update();
                                } else {
                                    setShowPrimaryFailMessage(true);
                                    setPrimaryFailMessage(response.data.message);
                                }
                            })
                            .catch(error => {
                                console.error('There was an error!', error);
                                setModalText(unknownText);
                                editFailModal.current.open();
                            });
                    } else if (response === LockType.LOCK_EXISTS) {
                        setModalText(lockedText);
                        editFailModal.current.open();
                    } else {
                        setModalText(changedText);
                        editFailModal.current.open();
                    }
            }).catch(() => {
                setModalText(unknownText);
                editFailModal.current.open();
        })
    };

    function handleClick() {
        if (token) {
            setIsOpen(prev => !prev);
        } else {
            setModalText(loginToAddSecondary)
            loginModal.current.open();
        }
    }

    function shouldShowDelButton(game) {
        return (game.pattern_secondary_game_user_id && game.pattern_secondary_game_user_id == userId)// eslint-disable-line eqeqeq
            || authors.some(author => author == userId) || (game.creator_user_id && game.creator_user_id == userId) // eslint-disable-line eqeqeq
        || +permissions.delete_patterns === 1;
    }

    function sendVote(vote, game_id) {
        if (token) {
            axios.get(apiUrl + "Vote/vote?vote=" + vote + "&token=" + token + "&primary_id=" + patternId + "&secondary_id=" + game_id + '&vote_type=EXAMPLE_GAME')
                .then(update).catch(() => console.log("Vote Failed"));
        } else {
            setIsPopoverOpen(false);
            setModalText(loginToRate);
            loginModal.current.open();
        }
    }

    async function requestEdit() {
        try {
            const response = await getEditLock(token, patternId, LockType.EXAMPLE_GAME, pattern_games.game_id);

            console.log(response)

            if (response === LockResponses.LOCK_EXISTS) {
                overrideModal.current.open();
            } else if (response === LockResponses.LOCK_CREATED) {
                setEditDesc(pattern_games.example_description);
                setEditDesignProblems(pattern_games.design_problems);
                setEditHistoryVersion(pattern_games);
                setIsEditing(true);
            }
        } catch (error) {
            //TODO: modal with error text????
            console.error("Error requesting edit lock:", error);
        }
    }

    async function overrideLock() {
        try {
            const response = await overrideEditLock(token, patternId, LockType.EXAMPLE_GAME, pattern_games.game_id)

            if (response === LockResponses.LOCK_CREATED) {
                setEditDesc(pattern_games.example_description);
                setEditDesignProblems(pattern_games.design_problems);
                setEditHistoryVersion(pattern_games);
                setIsEditing(true);
            }
        } catch {
            console.error('Edit Failed due to inability to override lock')
        }
    }

    const handleEditButton = () => {
        if (!isEditing) {
            requestEdit();
        } else {
            handleEditCancel();
        }
    }

    function handleEditCancel() {
        setEditDesc("");
        setEditDesignProblems([]);
        setEditHistoryVersion({})
        setIsEditing(false);
        setActiveHistory(activeHistory.filter((gameId) => {return gameId !== pattern_games.game_id}))
        cancelEditLock(token, patternId, LockType.EXAMPLE_GAME, pattern_games.game_id).catch(e => console.error('failed to cancel lock', e))
    }

    function handleOverride() {
        overrideLock().then(() => overrideModal.current.close())
    }

    const carrotDest = () => {
        let total = -25;
        showButtons && (total -= 25);
        shouldShowDelButton(pattern_games) && showButtons && (total -= 50);
        (pattern_games.user_display_name || pattern_games.additional_authors.length > 0) && showButtons && (total -= 25);
        (pattern_games.user_display_name || pattern_games.additional_authors.length > 0) && showButtons && shouldShowDelButton(pattern_games) && (total += 5)
        return total;
    };

    function getAssessment(up, down) {
        const totalVotes = up + down;
        const percent = (up / totalVotes) * 100;

        return totalVotes === 0 ? { assess: "None", color: "gray" } : findAssessment(percent, totalVotes);
    }

    const assess = getAssessment(pattern_games.up_votes, pattern_games.down_votes);

    const popup = (
        <motion.div className="secondary-popup" variants={appearAndExit} initial="closed" animate="open" exit="closed">
            <form onSubmit={(event) => {
                event.preventDefault();
                handleAddSecondaryGame();
            }} className="secondary-form">
                <Select
                    className="allow-overflow"
                    defaultValue={{
                        value: null, label: null, isFixed: true, isDisabled: true
                    }}
                    options={gameList}
                    menuPortalTarget={document.body}
                    styles={{
                        menu: (styles) => {
                            return {
                                ...styles,
                                top: -75,
                                left: -8,
                                textAlign: "left",
                                color: "gray",
                                fontWeight: "bold",
                                margin: 10,
                                fontSize: 16
                            };
                        },
                    }}
                    closeMenuOnSelect={true}
                    onChange={(val) => {
                        setAddGame(val.value);
                    }}
                    // style={{zIndex: 999, overflow: "visible", position: "relative", color: "red"}}
                />
                <Button className="secondary-cancel-button" onClick={() => setIsOpen(false)}>Cancel</Button>
                <SubmitButtonWarning
                    token={token} userId={userId}
                    handleSubmit={handleAddSecondaryGame}
                    failMessage={secondaryFailMessage}
                    setShowFailMessage={setShowSecondaryFailMessage}
                    showFailMessage={showSecondaryFailMessage}
                    postType={{
                        lowercase: "secondary example games",
                        capital: "Secondary Example Game",
                        capitalLowercase: "Secondary example games",
                    }}
                    submitButton={
                        <Button className="secondary-submit-button" type="submit">Submit</Button>
                    }
                />
            </form>
        </motion.div>);

    const carrotToExpand = (
        <motion.div
            key={`expand-carrot-${pattern_games.game_id}-${patternId}-horizontal`}
            animate={{
                x: carrotDest()
            }}
            style={{position: "absolute", display: "inline-flex"}} transition={{duration: 0.5, ease: "easeInOut"}}
        >
            {pattern_games.hidden_content
                ? <span style={{color: "#bf8888", fontWeight: "bold", alignItems: "center", display: "flex"}}>
                        Hidden Content
                    <OverlayTrigger
                        trigger={["hover", "focus"]}
                        rootClose
                        rootCloseEvent="click"
                        placement='bottom'
                        overlay={
                            <Popover id='hidden-content-info' style={{maxWidth: 1000}}>
                                <Popover.Title as="h3">Hidden Content</Popover.Title>
                                <Popover.Content className="hidden-content">
                                    {"This example game is hidden because the user who last edited it doesn't have a shared contact email. "}
                                    {parseInt(userId) === parseInt(pattern_games.version_selector_user_id)
                                        ? <><br/><br/>Add and share a valid contact email to make this example game visible to other users on the site. You can do this by
                                            editing your User Profile, entering a valid contact
                                            email, then click "Display Contact Email."</>
                                        : (authors && authors.some(author => author === parseInt(userId))) || permissions.edit_patterns
                                            ? <React.Fragment>{"\n\nTo make this example game visible, users who "}
                                                {authors && authors.some(author => author === parseInt(userId)) ? "are pattern authors " : ""}
                                                {authors && authors.some(author => author === parseInt(userId)) && permissions.edit_patterns ? "or " : ""}
                                                {permissions.edit_patterns ? "have permission to edit patterns " : ""}
                                                {"can verify this game by liking or editing it. \n\nFirst, make sure " +
                                                    "you have a valid contact email and check \"Display Contact Email\" " +
                                                    "in your User Profile. Then, like or edit this game to verify it. \n\n"}
                                                <i>If you bless this example game, it will remain verified until it is
                                                    edited by a user without a shared contact email. If you edit this
                                                    example game, it will remain verified until you unshare or remove
                                                    your contact email.
                                                </i>
                                            </React.Fragment>
                                            : ""}
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <VisibilityOff style={{transform: "scale(0.9)", marginLeft: 3}}/>
                    </OverlayTrigger>
                </span>
                : ''}
            <motion.div
                key={`expand-carrot-${pattern_games.game_id}-${patternId}-rotate`}
                animate={{
                    rotate: showButtons ? 90 : -90,
                }}
                onClick={() => setShowButtons(prev => !prev)}
                style={{display: "inline-flex"}} transition={{duration: 0.5, ease: "easeInOut"}}
            >
                <ExpandMoreIcon/>
            </motion.div>
        </motion.div>
    );

    const deleteButton = <AnimatePresence> {shouldShowDelButton(pattern_games) && showButtons && (
        <motion.div initial={{opacity: 0, x: 15}} animate={{opacity: 1, x: 0}} exit={{opacity: 0, x: 15}}
                    transition={{duration: .5, ease: "easeInOut"}}>
            <OverlayTrigger
                trigger="click"
                rootClose
                rootCloseEvent="click"
                placement='bottom'
                onToggle={() => setIsDelOpen(false)}
                show={isDelOpen}
                overlay={<Popover id='pattern-game-description'>
                    <Popover.Content className="game-description">
                        Are you sure you want to delete this game?
                        <Button onClick={() => handleDeleteAnyGame(pattern_games.game_id, false)} size={"sm"}
                                variant="primary" type="submit" className="delete-confirm-button">Delete</Button>
                    </Popover.Content>
                </Popover>}
            >
                <Tooltip title={"Delete"} placement="top">
                    <RemoveCircleOutline onClick={() => setIsDelOpen(prev => !prev)}
                        className="delete-icon"
                    ></RemoveCircleOutline>
                </Tooltip>
            </OverlayTrigger></motion.div>)}</AnimatePresence>


    const likeButton = <AnimatePresence> {showButtons && (<Tooltip title="Agree" placement="top">
            <motion.div
                initial={{opacity: 0, x: 15}}
                animate={{opacity: 1, x: 0}}
                exit={{opacity: 0, x: 15}}
                transition={{duration: 0.5, ease: "easeInOut"}}
                style={{display: 'inline-block'}}
            >
                <motion.div
                    whileTap={{
                        scale: 1.2,
                        rotate: [0, -15, 0, 15, 0],
                        transition: {type: "spring", stiffness: 300, damping: 10, duration: 0.5}
                    }}
                    style={{fontWeight: "normal", color: "black", alignItems: "center"}}
                >
                    <ThumbUp onClick={() => {
                        sendVote(pattern_games.user_vote === 1 ? 0 : 1, pattern_games.game_id)
                    }} color={pattern_games.user_vote === 1 ? "inherit" : "action"} style={{
                        width: '20px',
                        height: '20px', marginRight: "4px"
                    }}/>
                </motion.div>
            </motion.div>
        </Tooltip>
    )} </AnimatePresence>;

    const dislikeButton = <AnimatePresence>{showButtons && (<Tooltip title="Disagree" placement="top">
            <motion.div
                initial={{opacity: 0, x: 15}}
                animate={{opacity: 1, x: 0}}
                exit={{opacity: 0, x: 15}}
                transition={{duration: 0.5, ease: "easeInOut"}}
                style={{display: 'inline-block'}}
            >
                <motion.div
                    whileTap={{
                        scale: 1.2,
                        rotate: [0, -15, 0, 15, 0],
                        transition: {type: "spring", stiffness: 300, damping: 10, duration: 0.5}
                    }}
                    style={{fontWeight: "normal", color: "black", alignItems: "center"}}
                >
                    <ThumbDown onClick={() => {
                        sendVote(pattern_games.user_vote === -1 ? 0 : -1, pattern_games.game_id)
                    }} color={pattern_games.user_vote === -1 ? "inherit" : "action"} style={{
                        width: '20px',
                        height: '20px', marginRight: "4px"
                    }}/>
                </motion.div>
            </motion.div>
        </Tooltip>
    )} </AnimatePresence>;

    const ratingButton = <AnimatePresence>{showButtons && (
        <motion.div
            initial={{opacity: 0, x: 15}}
            animate={{opacity: 1, x: 0}}
            exit={{opacity: 0, x: 15}}
            transition={{duration: 0.5, ease: "easeInOut"}}
            style={{display: 'inline-block'}}
        >
            <OverlayTrigger
                trigger="click"
                rootClose
                rootCloseEvent="click"
                placement='bottom'
                onToggle={() => setIsPopoverOpen(false)}
                show={isPopoverOpen}
                overlay={<Popover id='pattern-game-description'>
                    <Popover.Title>Rate This Example</Popover.Title>
                    <Popover.Content className="game-description">
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: "space-between",
                            minWidth: "200px"
                        }}>
                            <p style={{
                                margin: 0,
                                lineHeight: '1.5'
                            }}>{"Total Votes: " + (pattern_games.up_votes + pattern_games.down_votes)}</p>
                            <div style={{gap: '5px', justifyContent: "normal"}}>
                                {likeButton}
                                {dislikeButton}
                            </div>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px'}}>
                            <span>Developer Assessment:</span>
                            <p style={{color: assess.color, margin: 0}}>{assess.assess}</p>
                        </div>
                    </Popover.Content>
                </Popover>}>
                <Tooltip title={"Rating"} placement="top">
                    <ThumbsUpDown className="rating-icon" onClick={() => setIsPopoverOpen(prev => !prev)}/>
                </Tooltip>
            </OverlayTrigger>
        </motion.div>
    )} </AnimatePresence>;

    const editButton = <AnimatePresence>{shouldShowDelButton(pattern_games) && showButtons && (<Tooltip title="Edit" placement="top">
        <motion.div initial={{opacity: 0, x: 15}} animate={{opacity: 1, x: 0}} exit={{opacity: 0, x: 15}}
                    transition={{duration: .5, ease: "easeInOut"}}>
            <Edit className="edit-icon"
                onClick={handleEditButton}/>
        </motion.div></Tooltip>)}
    </AnimatePresence>

    const suggesterInfoButton = <AnimatePresence>{(pattern_games.user_display_name || pattern_games.additional_authors.length > 0) && showButtons && (
        <motion.div initial={{opacity: 0, x: 15}} animate={{opacity: 1, x: 0}} exit={{opacity: 0, x: 15}}
                           transition={{duration: .5, ease: "easeInOut"}}>
            <OverlayTrigger
                trigger="click"
                rootClose
                rootCloseEvent="click"
                placement='bottom'
                onToggle={closeSuggestedPopover}
                show={isSuggestedOpen}
                overlay={<Popover id='pattern-game-description'>
                    <Popover.Title>
                        {pattern_games.user_display_name ?
                            <div style={{textAlign: "center"}}>Suggested By:<span className="example-suggested-link"
                                                                                  onClick={() => {
                                                                                      openUserProfile(pattern_games.creator_user_id);
                                                                                      closeSuggestedPopover();
                                                                                  }}>
                        <PersonRounded style={{marginTop: -3}}/>{pattern_games.user_display_name}
                    </span></div>
                            : <div
                                style={{textAlign: "center"}}>{authors && authors.length > 1 ? "Submitted By Pattern Authors" : "Submitted By A Pattern Author"}</div>}
                    </Popover.Title>
                    <Popover.Content className="game-description">
                        {pattern_games.user_display_name && pattern_games.additional_authors.length === 0 && (<>Suggested By:
                            <span className="example-suggested-link" onClick={() => {openUserProfile(pattern_games.creator_user_id); closeSuggestedPopover();}}>
                        <PersonRounded style={{marginTop: -3}}/>{pattern_games.user_display_name}
                    </span></>)
                    }
                    <ol style={{listStyle: "none", padding: 0, margin: 0}}>
                        {pattern_games.additional_authors.length > 0 && pattern_games.additional_authors.map((u, index) => {
                            return <li key={pattern_games.game_id + " editor " + u.user_id + " index: " + index}>Edited By:<span className="example-suggested-link" onClick={() => {
                                openUserProfile(u.user_id);
                                closeSuggestedPopover();
                            }}>
                                            <PersonRounded style={{marginTop: -3}}/>{u.display_name}
                            </span><div style={{float: "right", marginLeft: 20}}>{formatDate(u.timestamp, 'MM/DD/YY')}</div></li>
                        })}
                        </ol>
                    </Popover.Content>
                </Popover>}
            >
                <Tooltip title={!isSuggestedOpen ? ((!pattern_games.user_display_name) ? "Edited By" : "Suggested By"): ""} placement="top">
                    <div style={{display: "flex"}} onClick={() => setIsSuggestedOpen(prev => !prev)}>
                        <SuggestedIcon className="suggested-icon"/>
                    </div>
                </Tooltip>
            </OverlayTrigger>
        </motion.div>
    )}</AnimatePresence>

    const problemOptions =  designProblems && designProblems.length > 1 ?
        designProblems.map((problem, index) => ({ value: problem.design_problem_id, label: "Design Problem " + (index + 1) }))
        : []

    const handleHistoryChange = (historyChange) => {
        if (historyChange) {
            setEditDesc(historyChange.example_description)
            setEditHistoryVersion(historyChange)
        }
    }

    const handleActiveHistory = (activeHistory) => {
        setActiveHistory(activeHistory)
    }

    const editPattern = <div className="secondary-popup"><Form
        className="secondary-form" style={{marginBottom: 0}}
        onSubmit={(event) => {
            event.preventDefault();
            handleEditExampleGame();
        }}
    >
        <Form.Group controlId="editDescription" style={{marginBottom: 0}}>
            <TextAreaWithTabs
                rows={3}
                value={editDesc}
                onChange={(e) => setEditDesc(e.target.value)}
                required
            />
        </Form.Group>
        <EditHistoryWrapper
            style={{marginBottom: 10}}
            token={token}
            history_id={editHistoryVersion.history_id}
            pattern_id={editHistoryVersion.pattern_id}
            component_id={editHistoryVersion.game_id}
            handleHistoryChange={handleHistoryChange}
            handleActiveHistory={handleActiveHistory}
            activeHistories={activeHistory}
            component_text_field={editDesc}
            component={editHistoryVersion}
            flag={"PRIMARY_GAME"}
            keyStr={"example-game-history-" + editHistoryVersion.game_id}
            isActive={activeHistory.includes(editHistoryVersion.game_id)}
            openUserModal={() => {
                openUserProfile(editHistoryVersion.editor_user_id);
            }}
        />
        {designProblems && designProblems.length > 1
            ? <Select
                className="design-problem-selector"
                isMulti={true}
                menuPortalTarget={document.body} // Attach to body to prevent overflow issues
                menuPosition="absolute" // Ensures dropdown stays positioned relative to input
                menuShouldScrollIntoView={false} // Prevent unwanted scroll behavior
                styles={{
                    menuPortal: (base) => ({...base, marginTop: -75, zIndex: 500, textAlign: "left"}), // Ensure proper zIndex and adjust position with margin.
                }}
                defaultValue={designProblems && designProblems.length > 0 && pattern_games.design_problems && pattern_games.design_problems.length > 0
                    ? pattern_games.design_problems.map(design_problem_id => {
                        return problemOptions.find(option => option.value === design_problem_id)
                            || ''
                    }) : ''}
                placeholder="Which design problems are solved by this example?"
                options={problemOptions}
                onChange={(val) => setEditDesignProblems(val ? val.map(e => e.value) : [])}
            /> : ''}
        <Button variant="danger" onClick={handleEditCancel} className="preset-modal-cancel-button" style={{
            // backgroundColor: 'red',
            // borderColor: 'red',
            color: 'white',  // Adjust this color to match the picture color
            float: "right"
        }}>Cancel</Button>
        <SubmitButtonWarning
            token={token} userId={userId}
            handleSubmit={handleEditExampleGame}
            failMessage={primaryFailMessage}
            setShowFailMessage={setShowPrimaryFailMessage}
            showFailMessage={showPrimaryFailMessage}
            postType={{
                lowercase: "example games",
                capital: "Example Game",
                capitalLowercase: "Example games",
            }}
            submitButton={
                <Button variant="primary" type="submit" className="preset-modal-button-button" style={{
                    float: 'right',
                    marginRight: '10px',
                }}>Submit</Button>
            }
        />
        <span style={{color: "gray", float: "right", display: "inline-flex", justifyContent: "center",
            alignItems: "center", marginRight: "20px", marginTop: "6px"}}>
            <Tooltip title="Example Locked for Editing" placement="top">
                <Lock />
            </Tooltip>
            <Timer
                style={{marginBottom: 0, marginLeft: "5px"}}
                hours={0} minutes={59} seconds={59} onComplete={() => {
                    setModalText(expiredText);
                    editFailModal.current.open();
                }}
            />
        </span>
    </Form></div>


// this handles the game titles and their associated animations.
    const gameTitle = (game, isSecondary = false, index = 0) => (
        <motion.div
            className="secondary-mini-container"
            style={{position: 'relative'}}
            key={game.game_name + game.game_id}
        >
            <motion.dt className={"game-title"} style={pattern_games.hidden_content ? {borderBottom: "2px solid #bf8888"} : {}}>
                <div className="left-box">
                    {game.game_name + " "}
                </div>
                <div className="right-box" style={pattern_games.hidden_content ? {minWidth: -1 * carrotDest() + 165} : {minWidth: -1 * carrotDest() + 20}}>
                    {deleteButton}
                    {editButton}
                    {ratingButton}
                    {suggesterInfoButton}
                    {carrotToExpand}
                    <OverlayTrigger
                        trigger="click"
                        rootClose
                        rootCloseEvent="click"
                        placement='bottom'
                        overlay={<Popover id='pattern-game-description'>
                            <Popover.Title as="h3">Game Description — {game.game_name}</Popover.Title>
                            <Popover.Content className="game-description">
                                {game.game_description} —
                                <NavLink
                                    to={'/PatternLibraryApp/GamesReference/' + game.game_id}
                                    exact
                                >
                                    <span className="view-game-link" onClick={() => {
                                        gameSelected(game.game_id);}}
                                    >
                                        View Game Details
                                    </span>
                                </NavLink>
                            </Popover.Content>
                        </Popover>}
                    >
                        <Tooltip title="Info" placement="top">
                            <InfoOutlined className="new-info-icon"/>
                        </Tooltip>
                    </OverlayTrigger>
                </div>
            </motion.dt>
        </motion.div>);



    const isSecondaryGame = pattern_games.secondary_games.length > 0;
    const secondaryGameTitle = (is_secondary_game) => is_secondary_game ? "Games with similar implementation:" : "Add a game with similar implementation:";
    const secondaryGameTextStyle = (is_secondary_game) => is_secondary_game ? "secondary-title" : "secondary-title-add-game";


    return (<motion.div className="game-border" variants={appearAndExit} initial="closed" animate="open" exit="closed" style={pattern_games.hidden_content ? {border:  "2px solid #bf8888"} : {}}>
        {gameTitle(pattern_games)}
        <div className="game-body">
            <AnimatePresence exitBeforeEnter>
                {isEditing ? (
                    <motion.div
                        key="editPattern"
                        variants={appearAndExit}
                        initial="closed"
                        animate="open"
                        exit="closed"
                    >
                        {editPattern}
                    </motion.div>
                ) : (
                    <motion.div
                        key="exampleDescription"
                        variants={appearAndExit}
                        initial="closed"
                        animate="open"
                        exit="closed"
                        style={{marginBottom: 0, whiteSpace: "pre-wrap"}}
                    >
                        {formatParagraphs(pattern_games.example_description)}
                    </motion.div>
                )}
            </AnimatePresence>
            <div className="secondary-mini-container">
                <AnimatePresence exitBeforeEnter>
                    <motion.h3
                        className={secondaryGameTextStyle(isSecondaryGame)}
                        key={secondaryGameTitle(isSecondaryGame) + pattern_games.game_id}
                        initial={{opacity: 0, y: -20, className: secondaryGameTextStyle(!isSecondaryGame)}}
                        animate={{opacity: 1, y: 0}}
                        exit={{opacity: 0, y: 20, className: secondaryGameTextStyle(isSecondaryGame)}}
                        transition={{duration: 0.5}}
                        style={{marginTop: "10px"}}
                    >
                        {secondaryGameTitle(isSecondaryGame)}
                    </motion.h3>
                </AnimatePresence>
                <AddCircleOutlineIcon
                    onClick={handleClick}
                    onMouseEnter={() => setPlusIsHovered(true)}
                    onMouseLeave={() => setPlusIsHovered(false)}
                    style={{
                        color: plusIsHovered ? "#00bd00" : "green",
                        transform: plusIsHovered ? 'scale(1.2)' : 'scale(1)',
                    }}/>
            </div>
            {pattern_games.secondary_games.map((e, index) => {
                return <SecondaryExampleGame game={e} index={index} gameSelected={gameSelected}
                                             handleDeleteAnyGame={handleDeleteAnyGame} history={history}
                                             shouldShowDelButton={shouldShowDelButton} token={token}
                                             userId={userId}
                                             patternId={patternId} upperGameId={pattern_games.game_id}
                                             update={update}
                                             authors={authors}
                                             permissions={permissions}
                                             key={e.game_id + " secondary of " + pattern_games.game_id + " pattern " + patternId}
                                             patternSelected={patternSelected}
                                             allGames={allGames} getAssessment={getAssessment}/>
            })}
            {designProblems.length > 1 && pattern_games.design_problems && pattern_games.design_problems.length > 0
                ? <AnimatePresence exitBeforeEnter>
                    {isEditing ? (
                        <motion.div
                            key={"edit-design-problems-" + pattern_games.game_id}
                            variants={appearAndExit}
                            initial="closed"
                            animate="open"
                            exit="closed"
                        />
                    ) : (
                        <motion.div
                            key={"linked-design-problems-" + pattern_games.game_id}
                            variants={appearAndExit}
                            initial="closed"
                            animate="open"
                            exit="closed"
                            style={{marginBottom: 0, whiteSpace: "pre-wrap"}}
                        >
                            <span style={{display: 'inline-flex', whiteSpace: 'break-spaces'}}><div>Solves design problem{pattern_games.design_problems && pattern_games.design_problems.length > 1 ? 's' : ''}: </div>{pattern_games.design_problems.map((problem, index) => {
                                let option = problemOptions.find(option => option.value === problem);
                                let designProblem = designProblems.find(design_problem => design_problem.design_problem_id === problem)
                                let order_id = "0";
                                if (option) {
                                    order_id = option.label.substring(option.label.length - 1)
                                }
                                return <OverlayTrigger
                                    key={"linked-design-problems-" + pattern_games.game_id + "-" + order_id}
                                    rootClose
                                    rootCloseEvent="click"
                                    placement='bottom'
                                    overlay={
                                        <Popover id='pattern-game-description'>
                                            <Popover.Title>
                                                {option.label}
                                            </Popover.Title>
                                            <Popover.Content className="game-description">
                                                {designProblem ? designProblem.design_problem : ''}
                                            </Popover.Content>
                                        </Popover>
                                    }
                                >
                                    <div style={{marginLeft: 2, marginRight: 4}}><div style={{scale: "1.3"}}>{number_to_icon(order_id)}</div></div>
                                </OverlayTrigger>
                            })}</span>
                        </motion.div>
                    )}
                </AnimatePresence>
                : ''}
        </div>

        <AnimatePresence>{isOpen && popup}</AnimatePresence>
        <PresetModal ref={overrideModal} buttonText='Override' title='Override Editing Lock?'
                     body="Another user is currently editing this example game. If you choose to override this lock you may be overriding someone else's changes. If you don't want to override their lock please try again later."
                     onButtonPress={handleOverride}></PresetModal>
        <PresetModal ref={editFailModal} title={modalText.title} body={modalText.body}/>
        <PresetModal ref={loginModal} title={modalText.title}><Auth shouldRedirect hideDragon/></PresetModal>
    </motion.div>);
}
